//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
let d=[[[0,"BuildStatus",0,0],[0,"CenterHole",1,0],[0,"DesignStatus",1,0],[0,"Diameter",1,0],[0,"DisplayStatus",1,0],[0,"Height",1,0],[0,"HoleDiameter",1,0],[0,"Length",1,0],[0,"LocationOffset",1,0],[0,"Relief",1,0],[0,"ReliefDepth",1,0],[0,"ReliefWidth",1,0],[0,"ShapeType",1,0],[0,"SurfaceOffset",1,0],[0,"Width",1,0]],[[["title","value","color","diameter_title"],"GetHoleAttributes",{},0,0],[["title","value","color","diameter_title"],"SetHoleAttributes",{},4,0],[["title","value","color"],"GetPadAttributes",{},0,0],[["title","value","color"],"SetPadAttributes",{},3,0],[["title","value","color"],"GetReliefAttributes",{},0,0],[["title","value","color"],"SetReliefAttributes",{},3,0],[[],"CreateChild",{R_:{diepadchild:"Die.PadChildBuilder"}},0,0],[["diepadchild"],"DeleteChild",{},1,0],[["num_children"],"GetChildren",{R_:{children:"Die.PadChildBuilder[]"}},0,0]],[]];
SPLM.Die.PadParentBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.PadParentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.PadParentBuilder.ShapeTypeOption = Object.freeze({
    "Rectangular" : "Rectangular", "Circular" : "Circular", "Curve" : "Curve"});

export default SPLM;